'use client';

import {
  publicHttpClient,
  type DefaultQueryError,
} from '@ahm/api-wrappers-core';
import { useMutation, type UseMutationOptions } from '@tanstack/react-query';

export interface PasscodeRequestBody {
  new_passcode: string;
  token: string;
}

export type UpdatePasscodeResponse = {
  status: number;
};

export const updatePasscodeFn = async (body: PasscodeRequestBody) => {
  const params = {
    ...body,
  };
  const updatePasscode = '/api/v3/private/user/passcode';

  return await publicHttpClient.put<UpdatePasscodeResponse>(
    updatePasscode,
    params,
    {
      headers: {
        Authorization: `Bearer ${params.token}`,
      },
    }
  );
};

export const useUpdatePasscodeMutation = (
  opts?: UseMutationOptions<
    UpdatePasscodeResponse,
    DefaultQueryError,
    PasscodeRequestBody
  >
) =>
  useMutation<UpdatePasscodeResponse, DefaultQueryError, PasscodeRequestBody>({
    mutationFn: updatePasscodeFn,
    ...opts,
  });
